import {
  normalizeRegistryEntityType,
  isRegisteredEntityType
} from '@trip-planner-monorepo/shared/config/entityTypeRegistry';

const TRAVEL_SUBTYPES = ['travel', 'flight', 'train', 'bus', 'car', 'cruise', 'ferry'];
const ACCOMMODATION_SUBTYPES = [
  'accommodation',
  'hotel',
  'apartment',
  'house_villa',
  'resort',
  'hostel',
  'guesthouse',
  'camping',
  'custom'
];

/**
 * Maps UI/legacy subtype labels (e.g. resort, flight) to registry entity types.
 * @param {string} entityType
 * @returns {string}
 */
export function toRegistryEntityType(entityType) {
  if (!entityType) {
    return entityType;
  }
  const normalized = normalizeRegistryEntityType(entityType);
  if (isRegisteredEntityType(normalized)) {
    return normalized;
  }
  if (ACCOMMODATION_SUBTYPES.includes(entityType)) {
    return 'accommodation';
  }
  if (TRAVEL_SUBTYPES.includes(entityType)) {
    return 'travel';
  }
  return entityType;
}

/**
 * @param {string} typeA
 * @param {string} typeB
 * @returns {boolean}
 */
export function associationEntityTypesMatch(typeA, typeB) {
  return toRegistryEntityType(typeA) === toRegistryEntityType(typeB);
}

export { TRAVEL_SUBTYPES, ACCOMMODATION_SUBTYPES };
